import qs from "qs";
import authAxios, { authHeader } from "../../data";
import { IImpDistributionPost } from "../../../types/Distribuions";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/ImpoundDistributions", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: { impoundId: string | null }) => {
  const response = await authAxios.get("/api/ImpoundDistributions/Count", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const deleteOne = async (id: string) => {
  const response = await authAxios.delete("/api/ImpoundDistributions/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (request: IImpDistributionPost) => {
  const response = await authAxios.post("/api/ImpoundDistributions", request, {
    headers: authHeader(),
  });

  return response.data;
};

const DistributionService = {
  fetchAll,
  fetchCount,
  deleteOne,
  create,
};

export default DistributionService;
